// Axios
import axios from "axios";
// qs
import qs from "qs";
// Helpers
import { tokenizeUrl } from "./helper";
// Ducks
import { logout, setTokens } from "./auth.ducks";
import { setNotification } from "../components/SmartNotification/SmartNotification.ducks";

const DELETE = "DELETE";
const GET = "GET";
const POST = "POST";
const PUT = "PUT";

const performRequest = (request, method) => async (dispatch, getState) => {
  const { auth } = getState();
  const options = {
    baseURL: auth.baseURL
  };
  if (auth.token) {
    options.headers = {
      Authorization: `Bearer ${auth.token}`,
      Method: method || null
    };
  }
  const requestObject = axios.create(options);
  try {
    return await request(requestObject);
  } catch (error) {
    const apiPathTokenized = error.response ? tokenizeUrl(error.response.config.url) : [];
    if (
      error.response !== undefined &&
      error.response.status === 401 &&
      apiPathTokenized[apiPathTokenized.length - 1] !== "token"
    ) {
      try {
        const response = await dispatch(
          tokenPost({
            grant_type: "refresh_token",
            refresh_token: auth.refreshToken
          })
        );
        if (response.data) {
          await dispatch(setTokens(response.data.access_token, response.data.refresh_token));
          return await dispatch(performRequest(request));
        }
      } catch (error) {
        dispatch(logout());
        dispatch(
          setNotification({
            type: "info",
            titleTranslationKey:
              "modules.localization.register.anonymous.smartNotifications.label.authenticationExpireTitle",
            messageTranslationKey:
              "modules.localization.register.anonymous.smartNotifications.label.authenticationExpireMessage"
          })
        );
      }
    } else {
      throw error;
    }
  }
};

export const invalidPathObj = {
  data: {},
  statusText: "Invalid path received"
};

export function tokenPost(params) {
  return async (dispatch, getState) => {
    const { auth } = getState();

    const instance = axios.create({
      baseURL: auth.baseURL,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        locale: localStorage.getItem("i18nextLng")
      }
    });

    return await instance.post("/token", qs.stringify(params));
  };
}

export function _delete(path) {
  if (path) {
    return performRequest((requestObject) => requestObject.get(path), DELETE);
  }
  return () => invalidPathObj;
}

export function get(path) {
  if (path) {
    return performRequest((requestObject) => requestObject.get(path), GET);
  }
  return () => invalidPathObj;
}

export function post(path, params) {
  if (path) {
    return performRequest((requestObject) => requestObject.post(path, params), POST);
  }
  return () => invalidPathObj;
}

export function put(path, params) {
  if (path) {
    return performRequest((requestObject) => requestObject.post(path, params), PUT);
  }
  return () => invalidPathObj;
}
